var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointreq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D83F87;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.8,142.9c0.1-32.1-22-60-53.3-67.2c-5.6-1.3-10.7-1.9-15.8-1.9h-17.1v42.1c0,8.8-7,16-16,16 c-8.8,0-16-7.2-16-16V73.8H150.2v42.1c0,8.8-7.2,16-16,16c-9,0-16-7.2-16-16V73.8h-17.1c-4.8,0-9.6,0.5-14.2,1.6 c-31.9,6.7-54.8,34.9-54.9,67.5v10.6h376.8V142.9z M101.1,424.6H245c-12.6-21.7-19.2-46.4-19.2-71.5c0-79,64.2-143.2,143-143.2 c13.9,0,27.4,1.9,40,5.6v-30.1H32v170.2C32,393.8,63,424.6,101.1,424.6L101.1,424.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2,63.8c0-8.8-7.2-16-16-16c-9,0-16,7.2-16,16v9.9h32V63.8z M322.6,63.8c0-8.8-7-16-16-16 c-8.8,0-16,7.2-16,16v9.9h32V63.8z M368.8,241.9c-61.3,0-111,49.9-111,111.2s49.8,111,111,111S480,414.4,480,353.1 S430.1,241.9,368.8,241.9z M404.3,369.1h-19.5v19.4c0,8.8-7,16-16,16c-8.8,0-16-7.2-16-16v-19.4h-19.4c-9,0-16-7.2-16-16 c0-9,7-16,16-16h19.4v-19.5c0-8.8,7.2-16,16-16c9,0,16,7.2,16,16v19.5h19.5c8.8,0,16,7,16,16C420.3,361.9,413.1,369.1,404.3,369.1z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointreq);
export default __webpack_public_path__ + "static/media/Appoint req.33de6f182d939de30302f3a1c530ed2d.svg";
export { ForwardRef as ReactComponent };